"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSWRFetch = void 0;
var _fetching = require("@ori/fetching");
var _react = require("react");
// istanbul ignore file @preserve -- No need to test swr wrapper

const useSWRFetch = ({
  fallback,
  fetcher,
  key,
  skip
}) => {
  const formattedKey = JSON.stringify({
    key
  });
  const [currentKey, setCurrentKey] = (0, _react.useState)(null);
  const matchingKey = currentKey === formattedKey;
  const {
    data,
    error
  } = (0, _fetching.useSWR)(skip ? null : currentKey, fetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });
  const fetch = (0, _react.useCallback)(() => {
    if (!matchingKey) {
      setCurrentKey(formattedKey);
    }
  }, [formattedKey, matchingKey]);
  return (0, _react.useMemo)(() => ({
    data: data ?? fallback,
    error,
    fetch,
    isLoaded: matchingKey && data != null && error == null,
    isLoading: data == null && error == null
  }), [data, error, fallback, fetch, matchingKey]);
};
exports.useSWRFetch = useSWRFetch;